module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/outline-colored-buttons/outline-colored-buttons.component.scss
// module id = ./src/app/features/buttons/outline-colored-buttons/outline-colored-buttons.component.scss
// module chunks = main